module.exports = __webpack_public_path__ + "img/Gallery_3_04.cff38c8a.jpeg";